module.exports = __webpack_public_path__ + "img/rozliczenia.b617d5db.svg";